<template>
  <div class="institution-module">
    <b-row class="d-flex justify-content-around">
      <b-col
        lg="5"
        md="5"
        cols="6"
        class="content-section"
      >
        <b-card
          v-if="institution"
          title="Institution"
          tag="article"
          class="mb-2 content-wrapper"
        >
          <b-card-text class="text-light">
            <span class="font-weight-bold">Institution name:</span>
            {{ institution.name }}
          </b-card-text>

          <b-card-text class="text-light">
            <span class="font-weight-bold">Enrolment Code:</span>
            {{ institution.students_code }}
          </b-card-text>

          <b-card-text class="text-light">
            <span class="font-weight-bold">Expiration Date: </span>
            {{ institution.expiry_date }}
          </b-card-text>

          <b-card-text class="text-light">
            <span class="font-weight-bold">Used Seats: </span>
            {{ institution.used_seats }}/{{ institution.total_seats }}
          </b-card-text>

          <b-card-text class="text-light">
            <span class="font-weight-bold">User Maximum Tokens per Year: </span>
            {{ institution.user_max_token }}
          </b-card-text>

          <b-card-text class="text-light">
            <span class="font-weight-bold">Institution Maximum Tokens per Year: </span>
            {{ institution.institution_max_token }}
          </b-card-text>

          <b-card-text class="text-light">
            <span class="font-weight-bold">Deployment Name: </span>
            {{ institution.deploymentName }}
          </b-card-text>

          <b-card-text class="text-light">
            <span class="font-weight-bold">API Key: </span>
            {{ institution.apiKey }}
          </b-card-text>

          <b-card-text class="text-light">
            <span class="font-weight-bold">API Version: </span>
            {{ institution.apiVersion }}
          </b-card-text>

          <b-card-text class="text-light">
            <span class="font-weight-bold">Base URL: </span>
            <b-link :href="institution.baseUrl">
              {{ institution.baseUrl }}</b-link>
          </b-card-text>

          <b-card-text class="text-light">
            <span class="font-weight-bold">Azure Region: </span>
            {{ institution.azureRegion }}
          </b-card-text>
        </b-card>
      </b-col>

      <b-col
        lg="5"
        md="5"
        cols="6"
        class="content-section"
      >
        <b-card
          title="Students"
          tag="article"
          class="mb-2 content-wrapper"
        >
          <div v-if="studentDetails">
            <div class="student-table-container m-auto p-0">
              <div class="student-table-body mt-0">
                <center v-if="isLoading">
                  <b-spinner label="Spinning" />
                </center>
                <div
                  v-for="(s, index) in students"
                  :key="index"
                  :class="[
                    'student-row',
                    index % 2 === 0 ? 'bg-light-row' : 'bg-dark-row',
                  ]"
                >
                  <div class="left d-flex align-items-center pl-2">
                    <div class="avatar-box position-relative">
                      <b-avatar
                        :src="s.avatar"
                        size="32"
                      />
                      <span
                        class="status-dot"
                        :class="{
                          'bg-success': s.status === 'online',
                          'bg-danger': s.status === 'offline',
                        }"
                      />
                    </div>
                    <span class="ml-2 text-white-50">{{ s.fname }} {{ s.lname }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <b-link
                :to="{ name: 'users', params:{institution_id: institution.id} }"
                class="mt-1 small text-primary"
              >
                View All
              </b-link>
            </div>
          </div>
          <div v-else="studentDetails">
            <span>No Students</span>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  BRow,
  BCol,
  BProgress,
  BCard,
  BButton,
  BIcon,
  BImg,
  BCardText,
  BSpinner,
  BAvatar,
  BLink,
} from 'bootstrap-vue'

export default {
  name: 'ConcreteInstitutionPage',
  components: {
    BRow,
    BCol,
    BProgress,
    BButton,
    BIcon,
    BImg,
    BCard,
    BCardText,
    BSpinner,
    BAvatar,
    BLink,
  },
  computed: {
    ...mapGetters({
      institution: 'institutions/item',
      students: 'institutions/students',
    }),
    id() {
      return this.$route.params.id ? this.$route.params.id : null
    },
  },
  data() {
    return {
      studentDetails: [],
      isLoading: false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.isLoading = true
      this.$store.dispatch('institutions/students', { institution_id: this.id })
      this.$store.dispatch('institutions/get', this.id).then(response => {
        console.log('Response in detials vue: ', response)
        console.log('Inst.: ', this.institution)
        this.isLoading = false
        this.studentDetails = [
          {
            id: 1,
            name: 'Alice Johnson',
            status: 'online',
            avatar: 'https://randomuser.me/api/portraits/women/1.jpg',
          },
          {
            id: 2,
            name: 'Mark Rivera',
            status: 'offline',
            avatar: 'https://randomuser.me/api/portraits/men/2.jpg',
          },
          {
            id: 3,
            name: 'Sophia Lee',
            status: 'online',
            avatar: 'https://randomuser.me/api/portraits/women/3.jpg',
          },
          {
            id: 4,
            name: 'James Smith',
            status: 'offline',
            avatar: 'https://randomuser.me/api/portraits/men/4.jpg',
          },
          {
            id: 5,
            name: 'Olivia Davis',
            status: 'online',
            avatar: 'https://randomuser.me/api/portraits/women/5.jpg',
          },
        ]

        // this.studentDetails = this.students.data.map((student) => ({
        //   id: student.id,
        //   name: `${student.fname} ${student.lname}`,
        //   status: Math.random() > 0.5 ? "online" : "offline",
        //   avatar: "",
        // }));
      })
    },
    openInstitution(id) {
      if (id) {
      } else {
        console.log('No ID provided in the URL.')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.institution-module {
  padding: 2rem 1rem;
  animation: fadeIn 1s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .content-wrapper {
    max-width: 100%;
    animation: slideInLeft 1s ease forwards;
    color: #e9ecef;
    @keyframes slideInLeft {
      from {
        opacity: 0;
        transform: translateX(-30px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
  }

  .image-gallery {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
    animation: fadeIn 1.2s ease-in-out;

    .main-image-container {
      width: 100%;
      max-width: 355px;

      .main-image {
        width: 100%;
        height: auto;
        min-height: 300px;
        object-fit: cover;
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        transition: transform 0.4s ease;

        &:hover {
          transform: scale(1.03);
        }
      }
    }

    .thumbnail-column {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .thumbnail-container {
        width: 70px;
        height: 75px;
        overflow: hidden;

        .thumbnail-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

          &:hover {
            transform: scale(1.1);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          }
        }
      }
    }
  }

  .student-table-container {
    max-width: 90%;
    border-radius: 14px;
    overflow: hidden;
    backdrop-filter: blur(18px);
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
  }
  .student-table-body {
    max-height: 500px;
    overflow-y: auto;
  }

  .student-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 12px;
    transition: background 0.3s;
  }

  .bg-light-row {
    background-color: rgba(255, 255, 255, 0.07);
  }

  .bg-dark-row {
    background-color: rgba(255, 255, 255, 0.03);
  }

  .avatar-box {
    position: relative;
  }

  .status-dot {
    position: absolute;
    bottom: -1px;
    right: -1px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 1px solid #1f1f1f;
  }

  @media (max-width: 991px) {
    .image-gallery {
      justify-content: center;
      flex-direction: column;
      align-items: center;

      .thumbnail-column {
        flex-direction: row !important;
        justify-content: center;
        flex-wrap: wrap;

        .thumbnail-container {
          width: 60px;
          height: 60px;
        }
      }
    }
  }

  @media (max-width: 576px) {
    .institution-title {
      font-size: 1.75rem;
    }

    .institution-subtitle {
      font-size: 1rem;
    }

    .institution-seats {
      font-size: 0.9rem;
    }

    .thumbnail-column {
      .thumbnail-container {
        width: 50px;
        height: 50px;
      }
    }
  }
}
</style>
